import { FormItemProps } from '../templates/FormProps';
import FormTextEditor from '../templates/FormTextEditor';
import { FormInstance } from 'antd/lib/form';

interface Content extends FormItemProps {
  form: FormInstance;
  editItem: string;
  height?: number;
}

const Content = ({
  name = 'content',
  label = 'Content',
  placeholder = 'Enter Content',
  rules,
  required = true,
  form,
  editItem,
  height,
  ...props
}: Content) => {
  return (
    <FormTextEditor
      content={editItem}
      {...{ name, label, placeholder, form, required, rules, height }}
      {...props}
    />
  );
};

export default Content;
